import React from 'react'

import { array, object } from 'prop-types'

import ArticlePartners from '../../Primitive/ArticlePartners'

const PartnersWidget = ({ article: { partners } }) => {
  return <ArticlePartners partners={partners} />
}

PartnersWidget.propTypes = {
  article: object,
  partners: array
}

export default PartnersWidget
